import React from 'react';
import { i18n } from "engine/Contexts/AppProviders";
import {
  LEVELS_OPTIONS,
  PERIOD_OPTIONS,
  YEARS_OPTIONS,
  DAY_OF_WEEK_OPTIONS,
} from "utils/helpers/helper.constant";

import _local from "utils/localStorageUtils";
import { appHelper } from "appCapacitor/helpers";


const initForm = (key, fieldsArray) => {
  return [
    {
      key: key,
      parentName: i18n.t("pages.generalInfo"),
      parentLabel: i18n.t("pages.generalInfo"),
      children: [...fieldsArray],
    },
    {
      children: [
        {
          label: i18n.t("common.save"),
          name: "send",
          value: "send",
          type: "submit",
        },
      ],
    },
  ];
};

// Custom Form for Users
export const initFormsByRole = role => {
  const descriptionFields = [
    {
      label: i18n.t("inputs.formOfAddress.title"),
      name: "description.greeting",
      required: true,
      value: "",
      type: "select",
      selectContent: [
        {
          key: "M.",
          label: i18n.t("inputs.formOfAddress.male"),
          value: "M.",
        },
        {
          key: "Mme.",
          label: i18n.t("inputs.formOfAddress.female"),
          value: "Mme.",
        },
      ],
      col: 6,
    },
    {
      label: i18n.t("common.lastNameShort"),
      name: "description.lastname",
      required: true,
      value: "",
      type: "input",
      col: 9,
    },
    {
      label: i18n.t("common.firstName"),
      name: "description.firstname",
      required: true,
      value: "",
      type: "input",
      col: 9,
    },
  ];

  switch (role) {
    case "teacher":
      const formTeacher = [
        ...descriptionFields,
        {
          label: i18n.t("inputs.abbreviation"),
          name: "abbreviationName",
          required: false,
          value: "",
          type: "input",
          col: 24,
        },
        {
          label: i18n.t("inputs.emailPlaceholder"),
          name: "email",
          required: true,
          value: "",
          type: "email-validate",
          col: 24,
        },
        {
          label: i18n.t("inputs.passwordPlaceholder"),
          name: "password",
          required: true,
          value: appHelper?.isWeb ? process.env.DEFAULT_USER_PASSWORD : "",
          type: "password",
          col: 24,
        },
        {
          label: i18n.t("inputs.phoneNumberLabel"),
          name: "address.telephone",
          required: true,
          value: "",
          type: "phone",
          col: 24,
        },
        {
          label: "N° ID ISM",
          required: false,
          name: "ismTD",
          value: "",
          type: "input",
          col: 12,
        },
        {
          label: "N° AVS",
          required: false,
          name: "avsNumber",
          value: "",
          type: "input",
          col: 12,
        },
      ];
      return initForm("general_form_teacher", formTeacher);
    case "parent":
      const formParent = [
        ...descriptionFields,
        {
          label: i18n.t("inputs.emailPlaceholder"),
          name: "email",
          required: true,
          value: "",
          type: "email-validate",
          col: 24,
        },
        {
          label: i18n.t("inputs.passwordPlaceholder"),
          name: "password",
          required: true,
          value: appHelper?.isWeb ? process.env.DEFAULT_USER_PASSWORD : "",
          type: "password",
          col: 24,
        },
        {
          label: i18n.t("inputs.phoneNumberLabel"),
          required: true,
          name: "address.telephone",
          value: "",
          type: "phone",
          col: 24,
        },
        {
          label: i18n.t("inputs.addressStreet"),
          required: true,
          name: "address.street",
          value: "",
          type: "input",
          col: 24,
        },
        {
          label: i18n.t("inputs.addressCity"),
          required: true,
          name: "address.city",
          value: "",
          type: "input",
          col: 12,
        },
        {
          label: i18n.t("inputs.postalCode"),
          required: true,
          name: "address.zip",
          value: "",
          type: "input",
          col: appHelper?.isWeb ? 12 : 13,
        },
      ];
      return initForm("general_form_parent", formParent);

    case "admin":
      const formAdmin = [
        ...descriptionFields,
        {
          label: i18n.t("inputs.emailPlaceholder"),
          name: "email",
          required: true,
          value: "",
          type: "email-validate",
          col: 24,
        },
        {
          label: i18n.t("inputs.passwordPlaceholder"),
          name: "password",
          required: true,
          value: appHelper?.isWeb ? process.env.DEFAULT_USER_PASSWORD : "",
          type: "password",
          col: 24,
        },
        {
          label: i18n.t("inputs.phoneNumberLabel"),
          name: "address.telephone",
          required: true,
          value: "",
          type: "phone",
          col: 24,
        },
        {
          label: "N° ID ISM",
          required: false,
          name: "ismTD",
          value: "",
          type: "input",
          col: 12,
        },
        {
          label: "N° AVS",
          required: false,
          name: "avsNumber",
          value: "",
          type: "input",
          col: 12,
        },
      ];
      return initForm("general_form_admin", formAdmin);
  }
};

// Students General form
export const initFormsStudents = () => {
  const descriptionFields = [
    {
      label: i18n.t("inputs.formOfAddress.title"),
      name: "description.greeting",
      required: true,
      value: "",
      type: "select",
      selectContent: [
        {
          key: "M.",
          label: i18n.t("inputs.formOfAddress.male"),
          value: "M.",
        },
        {
          key: "Mme.",
          label: i18n.t("inputs.formOfAddress.female"),
          value: "Mme.",
        },
      ],
      col: 6,
    },
    {
      label: i18n.t("common.lastNameShort"),
      name: "description.lastname",
      required: true,
      value: "",
      type: "input",
      col: 9,
    },
    {
      label: i18n.t("common.firstName"),
      name: "description.firstname",
      required: true,
      value: "",
      type: "input",
      col: 9,
    },
  ];
  const mainFieldsStudent = [
    ...descriptionFields,
    {
      label: i18n.t("inputs.sex.title"),
      name: "sex",
      required: true,
      value: "male",
      type: "select",
      selectContent: [
        {
          key: "male",
          label: i18n.t("inputs.sex.male"),
          value: "male",
        },
        {
          key: "female",
          label: i18n.t("inputs.sex.female"),
          value: "female",
        },
      ],
      col: 12,
    },
    {
      label: i18n.t("inputs.birthdate"),
      name: "birthdate",
      required: true,
      value: "",
      type: "date",
      col: 12,
    },
    {
      label: i18n.t("labels.class"),
      name: "class_info._id",
      displayLabel: true,
      required: true,
      value: "",
      endponit: "classes/list",
      type: "axios-select",
      col: 24,
      itemCallback: item => ({
        key: item._id,
        label: item.title,
        value: item._id,
      }),
    },
    {
      label: i18n.t("inputs.addressStreet"),
      required: true,
      name: "address.street",
      value: "",
      type: "input",
      col: 24,
    },
    {
      label: i18n.t("inputs.addressCity"),
      required: true,
      name: "address.city",
      value: "",
      type: "input",
      col: 12,
    },
    {
      label: i18n.t("inputs.postalCode"),
      required: false,
      name: "address.zip",
      value: "",
      type: "input",
      col: 12,
    },
    {
      label: "N° ID ISM",
      required: false,
      name: "ismTD",
      value: "",
      type: "input",
      col: 12,
    },
    {
      label: "N° AVS",
      required: false,
      name: "avsNumber",
      value: "",
      type: "input",
      col: 12,
    },
  ];
  return initForm("general_form_student", mainFieldsStudent);
};
/*

abbreviation
:
"Allemand"
color
:
"#B620E0"
createdAt
:
"2023-08-07T12:38:09.035Z"
label
:
"Allemand"
name
:
"Allemand"
*/
// Courses General form
export const initFormsCourses = subjects => {
  const subjectsList = subjects
    ?.map(elem => {
      return {
        key: elem?.label || elem?.name || elem?.key || elem?.value,
        label: elem?.label || elem?.name || elem?.value || elem?.key,
        value: elem?.label || elem?.name || elem?.value || elem?.key,
        color: elem?.color || "#cccccc",
      };
    })
    .sort((a, b) => a?.label?.localeCompare(b?.label));

  const mainFieldsCourse = [
    {
      label: i18n.t("courses.subjectColor"),
      name: "subject.color", // for select-chain select field
      required: false,
      value: "",
      type: "hidden",
      col: 24,
    },
    {
      label: i18n.t("labels.subject"),
      name: "subject.name",
      required: true,
      chain: "subject.color",
      type: "select-chain",
      selectContent: (!!subjectsList && subjectsList) || [],
      col: 16,
    },
    {
      label: i18n.t("courses.nameOf"),
      name: "course_code",
      value: "",
      type: "input",
      col: 8,
    },
    {
      label: i18n.t("courses.year"),
      name: "year",
      required: true,
      value: "",
      type: "select",
      selectContent: YEARS_OPTIONS,
      col: 24,
    },
    {
      label: i18n.t("courses.dayOfTheWeek"),
      name: "course_week",
      required: true,
      value: "lundi",
      type: "select",
      selectContent: DAY_OF_WEEK_OPTIONS(),
      col: 8,
    },
    {
      label: i18n.t("inputs.startTime"),
      name: "course_time_start",
      required: true,
      value: "",
      type: "time-range",
      col: 8,
    },
    {
      label: i18n.t("inputs.endTime"),
      name: "course_time_end",
      required: true,
      value: "",
      type: "time-range",
      col: 8,
    },
    {
      label: i18n.t("labels.class"),
      name: "classes",
      displayLabel: true,
      required: true,
      value: [],
      endponit: "classes/list",
      type: "axios-select",
      optionLabelProp: "label", // 'label, title
      sortBy: "label",
      className: "axios-select",
      mode: "multiple",
      maxTagCount: "responsive",
      placeholder: i18n.t("classes.selectClasses"),
      col: 24,
      isSearch: true,
      itemCallback: item => {
        return {
          key: item?._id,
          label: item?.title,
          title: item?.title,
          value: item?._id,
        };
      },
      tagRender: props => (
        <span className="multiple-label-list">
          {props?.label || props?.title}
        </span>
      ),
    },
    {
      label: i18n.t("classes.classRoomNumber"),
      name: "class_room",
      value: "",
      type: "input",
      col: 8,
    },
    {
      label: i18n.t("labels.level"),
      name: "level",
      value: 0,
      type: "select",
      selectContent: LEVELS_OPTIONS(),
      col: 8,
    },
    {
      label: i18n.t("labels.period"),
      name: "period",
      value: 0,
      type: "select",
      selectContent: PERIOD_OPTIONS(),
      col: 8,
    },
  ];
  return initForm("general_form_course", mainFieldsCourse);
};

// Classes General form
export const initFormsClasses = () => {
  const teacherSelect = {
    label: i18n.t("classes.classIncumbentLabel"),
    name: "incumbent._id",
    displayLabel: true,
    required: false,
    endponit: "users/role",
    endponitSend: {
      role: "teacher",
    },
    type: "axios-select",
    col: 24,
    itemCallback: item => {
      return {
        key: item?._id,
        label: `${item?.description?.lastname} ${item?.description?.firstname}`,
        value: item?._id,
        item: item,
      };
    },
  };
  const mainFieldsClass = [
    {
      label: i18n.t("classes.year"),
      name: "year",
      required: true,
      value: "",
      type: "select",
      selectContent: YEARS_OPTIONS,
      col: 12,
    },
    {
      label: i18n.t("labels.class"),
      name: "title",
      required: true,
      value: "",
      type: "input",
      col: 12,
    },
    {
      label: i18n.t("labels.level"),
      name: "level",
      required: true,
      value: 0,
      type: "select",
      selectContent: LEVELS_OPTIONS(),
      col: 24,
    },
    {
      label: i18n.t("classes.classRoomNumber"),
      name: "class_room",
      value: "",
      type: "input",
      col: 24,
    },
    teacherSelect,
  ];
  return initForm("general_form_class", mainFieldsClass);
};

export const initFormsCommunication = (communicationDetail, includes = []) => {
  let audienceSelect = {
    label: i18n.t("labels.audience"),
    name: "audience-select",
    endponit: `communications/audience/by/schools,students,courses,classes,audiences,users`,
    endponitSend: {
      value: "",
      include: includes || [],
      firstLoad: true,
    },
    displayLabel: true,
    required: true,
    type: "axios-select-multiple",
    hasModeView: true,
    hiddenChain: "audience",
    col: 24,
    method: "POST",
    groupped: true,
    optionLabelProp: "title", // 'label
    value: [],
    className: "axios-select",
    mode: "multiple",
    isSearch: true,
    placeholder: i18n.t("audiences.selectAudience"),
    showAsTag: true,
    /*  tagRender: (props) => {
      console.log({ props });
      return <span className="multiple-label-list">{props.label}</span>;
    }, */
    /*  getResponse: response => {
      //console.log({ response });
    }, */
    onSearch: input => {},
    /*   itemCallback: item => ({
      key: item?.key || item?._id,
      title: item?.title,
      label: item?.label,
      value: item?.value,
      item: item,
    }), */
  };
  return [
    {
      key: "general_form_communication",
      parentName: "",
      parentLabel: "",
      children: [
        audienceSelect,
        {
          label: "",
          name: "audience",
          required: true,
          value: communicationDetail?.audience || {},
          type: "hidden",
          col: 24,
        },
        {
          label: i18n.t("common.title"),
          name: "title",
          required: true,
          value: communicationDetail?.title || "",
          type: "hidden",
          col: 24,
        },
        {
          label: "",
          name: "sender",
          required: true,
          value: null,
          type: "hidden",
          col: 24,
        },
        {
          label: "",
          name: "status",
          required: true,
          value: "draft",
          type: "hidden",
          col: 24,
        },
        {
          label: "",
          name: "thumbnail",
          required: false,
          value: "",
          type: "hidden",
          col: 24,
        },
        {
          label: "",
          name: "types",
          required: ["no-type"],
          value: null,
          type: "hidden",
          col: 24,
        },
        {
          label: i18n.t("inputs.deadlineForReply"),
          onlyReadLabel: i18n.t("inputs.deadline"),
          name: "deadlineDate",
          required: false,
          hasModeView: true,
          value: null,
          type: "date",
          col: 24,
        },
        {
          label: "",
          name: "description",
          required: true,
          value: "",
          type: "hidden",
          col: 24,
          placeholder: i18n.t("inputs.richEditorPlaceholderNews"),
        },
        {
          label: "",
          name: "description-editor",
          hiddenChain: "description",
          required: false,
          value: "",
          hasModeView: false,
          type: "rich-editor",
          type_editor: "simple",
          col: 24,
          placeholder: i18n.t("inputs.richEditorPlaceholderNews"),
          onChange: text => {
            //console.log({ text, form });
          },
        },
      ],
    },
    {
      children: [
        {
          label: i18n.t("common.save"),
          name: "send",
          value: "send",
          type: "submit",
        },
      ],
    },
  ];
};
